import { render, staticRenderFns } from "./OxygenMenuDropdown.vue?vue&type=template&id=17fd5eb8&"
import script from "./OxygenMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./OxygenMenuDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports